// PrivacyPage: Privacy policy
import React, { useEffect, useState } from 'react';
import PublicLayout from '../layouts/PublicLayout';
import { Box, Typography } from '@mui/material';
import { getCMS } from '../services/cms';
import { useTheme } from '@mui/material/styles';

function PrivacyPage() {
  const [bgMap, setBgMap] = useState({});
  const theme = useTheme();

  useEffect(() => {
    let mounted = true;
    getCMS().then(items => {
      if (!mounted) return;
      const landing = (items || []).find(i => i.type === 'landing');
      setBgMap(landing?.contentJSON?.backgrounds || {});
    }).catch(() => {}).finally(() => { mounted = false; });
  }, []);

  return (
    <PublicLayout>
      <Box sx={{ position: 'relative', width: '100%', minHeight: '56vh', py: { xs: 6, md: 8 }, overflow: 'hidden' }}>
        {bgMap.privacy && (
          <Box sx={{ position: 'absolute', inset: 0, backgroundImage: `url(${bgMap.privacy})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', zIndex: 0 }} />
        )}
        {bgMap.privacy && (
          <Box sx={{ position: 'absolute', inset: 0, bgcolor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.22)' : 'rgba(255,255,255,0.12)', zIndex: 0 }} />
        )}
        <Box sx={{ maxWidth: 1000, mx: 'auto', position: 'relative', zIndex: 1, p: { xs: 2, md: 3 } }}>
          <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">Privacy Policy</Typography>
            <Typography variant="body1">
              We value your privacy. All personal data is handled securely and in accordance with applicable laws. For details, please contact our support team.
            </Typography>
            <img src="/assets/privacy.jpg" alt="Privacy" style={{ width: '100%', borderRadius: 8, boxShadow: 2, marginBottom: 24, marginTop: 16 }} />
          </Box>
        </Box>
      </Box>
    </PublicLayout>
  );
}

export default PrivacyPage;
